import { render } from "./websiteDividerLarge.svg?vue&type=template&id=302019da"
const script = {}
script.render = render

export default script